import { isStringified } from '../utilities/stringified';
import { Persistence, PersistStorage } from '../types';

function wrapStorage(storage: Storage): Persistence {
  const api: Persistence = {
    get size() {
      return storage.length;
    },
    keys() {
      return Array.from({ length: this.size }, (_, idx) => storage.key(idx));
    },
    get(key, defaults = undefined) {
      const item = storage.getItem(key);
      return !item ? defaults : isStringified(item) ? JSON.parse(item) : item;
    },
    getAll() {
      return Object.fromEntries(this.keys().map((key) => [key, this.get(key as string, undefined)]));
    },
    set(key: string, value: unknown, stringify = true) {
      storage.setItem(key, stringify ? JSON.stringify(value) : (value as string));
    },
    remove: storage.removeItem.bind(storage),
    clear: storage.clear.bind(storage),
    key: storage.key.bind(storage),
    has(key) {
      return Boolean(storage.getItem(key));
    },
  };

  return api;
}

function defineStorage(): PersistStorage {
  return {
    local: wrapStorage(localStorage),
    session: wrapStorage(sessionStorage),
  };
}

/**
 * Create a wrapper around localStorage and sessionStorage.
 */
const storage = defineStorage();

export { storage };
